import { Button, Grid, IconButton } from "@mui/material";
import styles from "./NotableConcepts.module.scss";
import { useMemo, useState } from "react";
import { IconPack } from "Explore/Config/Icons";
import { numberRegex } from "Explore/Utils/numberRegex";
import LinkIcon from "@mui/icons-material/Link";
import useDeviceCheck from "Hooks/useDeviceCheck";
import SectionTitle from "Explore/Components/SectionTitle";
import KeywordCardInfo from "Explore/Components/KeywordCardInfo";
import { Modal } from "antd";
import useAuth from "Hooks/useAuth";
import LoginRequiredSection from "Explore/Components/LoginRequired";

const chunkSize = 2;

const NotableConcepts = ({
  notableConcepts,
  onClickExploreKeywordCallback,
  selectedKeywords = [],
}) => {
  const { userTypeConfig } = useAuth({
    entityType: "INSTITUTION",
  });
  const { isMobile } = useDeviceCheck();
  const {
    top_ranking_keywords: topRankingKeywords = [],
    top_keywords: topKeywords = [],
  } = notableConcepts || {};

  const [modalOpen, setModalOpen] = useState(false);
  const plainSelectedKeywords = selectedKeywords.map((e) => e.value);
  const notableConceptGroups = useMemo(() => {
    const selectedRankingKeywords = topRankingKeywords.filter((e) =>
      plainSelectedKeywords.includes(e.keyword)
    );
    let _topRankingKeywords = topRankingKeywords.filter(
      (e) => !plainSelectedKeywords.includes(e.keyword)
    );
    _topRankingKeywords = [...selectedRankingKeywords, ..._topRankingKeywords];
    // Limit to 6 items
    _topRankingKeywords = _topRankingKeywords.slice(0, 6);
    const chunks = [];
    for (let i = 0; i < _topRankingKeywords.length; i += chunkSize) {
      const chunk = _topRankingKeywords.slice(i, i + chunkSize);
      chunks.push(chunk);
    }
    return chunks;
  }, [topRankingKeywords, plainSelectedKeywords]);

  const render = () => {
    return (
      <div className={styles["notable-concepts--scroll"]}>
        <div className={styles["notable-concepts__container"]}>
          {notableConceptGroups.map((group, index) => (
            <div key={index} className={styles["notable-concepts--group"]}>
              {group.map((e, index) => (
                <KeywordCardInfo
                  className={styles["notable-concepts--item"]}
                  key={index}
                  data={e}
                  onClick={onClickExploreKeywordCallback}
                  isSelected={plainSelectedKeywords.includes(e.keyword)}
                />
              ))}
            </div>
          ))}
        </div>
        <Button
          className={styles["notable-concepts--btn"]}
          color="info"
          onClick={() => setModalOpen(true)}
        >
          {isMobile ? "See more" : "See more top concepts"}
        </Button>
      </div>
    );
  };

  return (
    <>
      {!!topRankingKeywords?.length ? (
        isMobile ? (
          <SectionTitle
            icon={IconPack.concept_outline_black}
            title="Notable Concepts"
            collapsible
            defaultOpen
          >
            {render()}
          </SectionTitle>
        ) : (
          render()
        )
      ) : (
        <></>
      )}
      <Modal
        title="All Top Concepts"
        onCancel={() => setModalOpen(false)}
        centered
        footer={null}
        width={isMobile ? "100dvw" : "80dvw"}
        open={modalOpen}
        styles={{ body: { padding: 0 } }}
      >
        <div className={styles["top-keywords-modal"]}>
          <div className={styles["scrollable-body"]}>
            {userTypeConfig?.ui_components?.topKeywords ? (
              <Grid container spacing={2}>
                {topKeywords.map((e, index) => (
                  <Grid item xs={6} md={4} lg={3} key={index}>
                    <KeywordCardInfo
                      data={e}
                      onClick={(e) => {
                        setModalOpen(false);
                        onClickExploreKeywordCallback(e);
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <LoginRequiredSection />
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default NotableConcepts;
